import { useTranslation } from 'react-i18next'

import { Alert } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DisableInstantRefundMethodsAlert = () => {
  const { t } = useTranslation()

  return (
    <Alert type="warning">
      {t(
        'Los métodos instantáneos no podrán deshabilitarse una vez habilitados. Si quieres cambiar la configuración, por favor contacta con'
      )}{' '}
      <Styles.LinkToSupport href="mailto:merchants@reveni.io">merchants@reveni.io</Styles.LinkToSupport>
    </Alert>
  )
}

export default DisableInstantRefundMethodsAlert
